module.exports = __webpack_public_path__ + "img/photographer_splash.66b58aeb.jpg";